import React, { useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText } from "../Form";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { ActionPermission, PageInfo } from "../PageInfo";
import { StandardConst } from "../../Services/StandardConst";
import { WSSuccessAlert } from "../../Services/WSAlert";
import { DateTime } from "luxon";
import { addDays } from "date-fns";

const { forwardRef, useState, useImperativeHandle } = React;

const ApproveRejectRegularization = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
  const [permission, SetPermission] = useState({});
const [mode, setMode] = useState("edit");
const Auth = useSelector((s) => s.auth ?? {});

useEffect(() => {
  if (Auth?.BasicInfo?.EmployeeId) {
    console.log("🔄 Auth Component mounted, fetching data...", Auth.BasicInfo.EmployeeId);
    // fetchEmpData();
  }
}, [Auth]);
//   useImperativeHandle(ref, () => ({
//     openModal: async (id) => {
//       const data = await WebService({
//         endPoint: `AttendanceRegularization/FetchDetails/${id || 0}`,
//         dispatch,
//       })
//         .then((c) => (c.length > 0 ? c[0] : {}))
//         .then((r) => ({ ...r, Comment: r.ApprovalNote }));

//       // Format times for display
//       if (data.CorrectedInTime) {
//         data.DisplayInTime = DateTime.fromSQL(data.CorrectedInTime).toFormat("hh:mm a");
//       }
//       if (data.CorrectedOutTime) {
//         data.DisplayOutTime = DateTime.fromSQL(data.CorrectedOutTime).toFormat("hh:mm a");
//       }
//       if (data.OriginalInTime) {
//         data.DisplayOriginalInTime = DateTime.fromSQL(data.OriginalInTime).toFormat("hh:mm a");
//       }
//       if (data.OriginalOutTime) {
//         data.DisplayOriginalOutTime = DateTime.fromSQL(data.OriginalOutTime).toFormat("hh:mm a");
//       }

//       setData(data);
//       setShow(true);
//     },
//   }));

console.log(permissionList,'Permitions');
const formatDate = (dateString, format = "DD-MM-YYYY") => {
  if (!dateString) return "";

  const d = new Date(dateString);
  const iso = d.toISOString().split("T")[0]; // YYYY-MM-DD

  if (format === "YYYY-MM-DD") return iso;

  // Convert to DD-MM-YYYY
  const [y, m, d2] = iso.split("-");
  return `${d2}-${m}-${y}`;
};


const RequestTypes = {
    'Missed Punch': 1,
    'Incorrect Punch': 2,
    'On Duty': 3,
    'Work from Home': 4,
    'Other': 5
  };
const formatTime = (timeString) => {
  if (!timeString) return "";
  return DateTime.fromSQL(timeString).toFormat("hh:mm a");  
};
useImperativeHandle(ref, () => ({
  openModal: async (id, mode = "edit") => { // Add mode parameter
    const data = await WebService({
      endPoint: `AttendanceRegularization/FetchDetails/${id || 0}`,
      dispatch,
    })
      .then((c) => (c.length > 0 ? c[0] : {}))
      .then((r) => ({ ...r, Comment: r.ApprovalNote }));

    // Format times for display
    if (data.CorrectedInTime) {
      data.DisplayInTime = DateTime.fromSQL(data.CorrectedInTime).toFormat("hh:mm a");
    }
    if (data.CorrectedOutTime) {
      data.DisplayOutTime = DateTime.fromSQL(data.CorrectedOutTime).toFormat("hh:mm a");
    }
    if (data.OriginalInTime) {
      data.DisplayOriginalInTime = DateTime.fromSQL(data.OriginalInTime).toFormat("hh:mm a");
    }
    if (data.OriginalOutTime) {
      data.DisplayOriginalOutTime = DateTime.fromSQL(data.OriginalOutTime).toFormat("hh:mm a");
    }

    setData(data);
    // setMode(mode); // Save the mode
     // If already approved, force view mode
     // ✅ If already approved, switch mode to view
     console.log(StandardConst.RegulrizationStatus.Approved ,'AJ');
    setMode(data.StatusId === StandardConst.RegulrizationStatus.Approved ? "view" : "edit");
    setShow(true);
  },
}));

PageInfo({ pageTitle: "Approve Regularization" });

  useEffect(() => {
    SetPermission({
      ManageApproveReject: ActionPermission("Attendance - Approve Reject"),
    });
  }, [permissionList]);

  const handleClose = () => setShow(false);

  const schema = yup
    .object()
    .shape({
      Comment: yup.string().when("StatusId", {
        is: (val) => val === StandardConst.RegulrizationStatus.Rejected,
        then: () => yup.string().required("Comment is required when rejecting"),
        otherwise: () => yup.string().notRequired(),
      }),
    })
    .required();

  const onSubmit = async (data) => {
    console.log(data,'--->>>>>');
    // alert(data?.StatusId);
    const datas = {
      RegularizationId: data.RegularizationId,
      StatusId: data.StatusId,
      ApprovalNote: data.Comment,
    };

    const responsedata = await WebService({
      endPoint: "AttendanceRegularization/ChangeStatus",
      body: datas,
      dispatch,
    });



    WSSuccessAlert("Success", responsedata.Message);
    handleClose();
    prop.callBackEvent();

  // Notifications Api
  console.log(responsedata, 'changed Status====', responsedata?.data);
const UpdatedStatus = responsedata?.data?.StatusId === 2 ? 'Approved' : 'Rejected';
    // Send notification only if EmployeeId exists
    if (responsedata?.data?.EmployeeId > 0 ) {
      const onlyDate =  responsedata?.data?.AttendanceDate.split("T")[0];


      if (responsedata?.data?.StatusId === 2) {
        const checkInResponse = await WebService({
          endPoint: "AttendanceRegularization/EmployeeCheckInCheckOut",
          dispatch,
          body: { 
            EmployeeId: responsedata?.data?.EmployeeId,  // Changed from 'id'
            CheckInDate: onlyDate,  // Changed casing
            CheckInTime: responsedata?.data?.CorrectedInTime,  // Changed casing
            CheckOutDate: onlyDate,  // Should be date, not time
            CheckOutTime: responsedata?.data?.CorrectedOutTime,  // Changed casing
            Latitude: null,  // Optional but good to include
            Longitude: null  // Optional but good to include
          },
        });

        console.log(checkInResponse.Message, "Check-In message----");
      }

      await WebService({
        dispatch,
        endPoint: "Notification/Create",
        body: {
          Message: `Manager has changed status to ${UpdatedStatus} for a regularization request on ${responsedata?.data.AttendanceDate.split("T")[0]}`,
          SendTo: [responsedata?.data?.EmployeeId], // ensure EmployeeId exists
          Expire: addDays(new Date(), 1),
        },
      });

      console.log('Notification sent');
      // EmployeeName
      console.log(data?.EmployeeName ,'Submited EMPLOYE NAME')
      
        // ====================Email====================
      
          const RequestTypesReverse = Object.fromEntries(
            Object.entries(RequestTypes).map(([key, value]) => [value, key])
          );
            const newData = {
              ...responsedata,                       // copy entire object
              EmployeeName: data?.EmployeeName || "" ,  // new field
              // EmployeeName: 'raja',
            
              StatusId:
                UpdatedStatus,
                  RequestTypeText: RequestTypesReverse[responsedata?.data?.RequestType] || "Unknown",
                  FormattedAttendanceDate: formatDate(responsedata?.data?.AttendanceDate),
                  FormattedRequestDate: formatDate(responsedata?.data?.RequestDate),
      
                  FormattedInTime: formatTime(responsedata?.data?.CorrectedInTime),
                  FormattedOutTime: formatTime(responsedata?.data?.CorrectedOutTime),
                  AppovalNote: responsedata?.data?.ApprovalNote,
                  approverName: Auth?.BasicInfo?.FullName || responsedata?.data?.ApprovedBy
            };
      
      
            

                console.log('Abhishek s/o RJ ==========>');

            console.log(newData,'--> new data');
            console.log(data.EmployeeId , 'YE HAI EMPLOYEEID');
                            console.log('Abhishek s/o RJ END ==========>');
                    // alert(data?.StatusId);
            await WebService({
              endPoint: "Email/send-regularization-ApprovalEmail",
              body: {'data':newData,'employeeID': responsedata?.data?.EmployeeId},
              dispatch,
            });
            // alert(responsedata?.data?.EmployeeId);
      
            // WSSuccessAlert(
            //   "Success",
            //   `mail send success fully successfully.`
            // );
            
            // =====================End
    }
  };

  const formRef = useRef();

  const styleObj = {
    fontSize: 14,
    fontFamily: "sans-serif",
    color: "rgb(108 106 106)",
    paddingTop: "6px",
  };
console.log('ab222');
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={handleClose}
      centered
      className="container-fluid"
    >
      <Modal.Header closeButton>
        <Modal.Title>Approve/Reject Regularization Request</Modal.Title>
      </Modal.Header>

      <Form
        ref={formRef}
        defaultValues={data}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        <Modal.Body className="p-4">
          <div className="row mt-1">
            <FormInputText
              label="Employee Name"
              name="EmployeeName"
              disabled={true}
            />
          </div>

          <div className="row mt-2">
            <FormInputText
              label="Request Date"
              name="RequestDate"
              type="date"
              disabled={true}
            />
          </div>

          <div className="row mt-2">
            <FormInputText
              label="Attendance Date"
              name="AttendanceDate"
              type="date"
              disabled={true}
            />
          </div>

          <div className="row mt-2">
            <FormInputText
              label="Request Type"
              name="RequestTypeName"
              disabled={true}
            />
          </div>

          {/* {data.DisplayOriginalInTime && (
            <>
              <div className="row mt-2">
                <div className="col-md-12">
                  <label style={styleObj}>
                    <strong>Original Punch Time</strong>
                  </label>
                </div>
              </div>
              <div className="row mt-2">
                
                  <FormInputText
                    label="In Time"
                    name="DisplayOriginalInTime"
                    disabled={true}
                  />
                </div>
               
                <div className="row mt-2">
                  <FormInputText
                    label="Out Time"
                    name="DisplayOriginalOutTime"
                    disabled={true}
                  />
              
              </div>
            </>
          )} */}

          {data.DisplayInTime && (
            <>
              <div className="row mt-2">
                <div className="col-md-12">
                  <label style={styleObj}>
                    {/* <strong>Requested Corrected Time</strong> */}
                  </label>
                </div>
              </div>
              <div className="row mt-2">
                {/* <div className="col-md-6"> */}
                  <FormInputText
                    label="In Time"
                    name="DisplayInTime"
                    disabled={true}
                  />
                </div>
                <div className="row mt-2">
                  <FormInputText
                    label="Out Time"
                    name="DisplayOutTime"
                    disabled={true}
                  />
                {/* </div> */}
              </div>
            </>
          )}

          <div className="row mt-2">
            <FormInputText
              name="Remarks"
              label="Employee's Reason"
              as="textarea"
              rows={3}
              disabled={true}
              //  disabled={mode === "view"}
            />
          </div>

          {data.Attachment && (
            <div className="row mt-2">
              <div className="col-md-12">
                <label style={styleObj}>Attachment</label>
                <br />
                <a href={`${StandardConst.apiBaseUrl}/uploads/${data.Attachment}` || "#"} target="_blank" rel="noopener noreferrer">
                  View Attachment
                </a>
              </div>
            </div>
          )}

          <div className="row mt-3">
            <FormInputText
              name="Comment"
              label="Manager's Comment/Reason (Mandatory for Rejection)"
              as="textarea"
              rows={3}
              placeholder="Add your comments here..."
            />
          </div>
        </Modal.Body>

        {/* {mode === "edit" &&  permission.ManageApproveReject && ( */}
        {/* Add Permitiin Conditions here Abhishek */}
        {/* {mode === "edit" && ( */}
          <Modal.Footer>
            <Button
              variant="success"
              id="btnApprove"
              type="submit"
               disabled={mode === "view"}
              onClick={() => {
                formRef.current.fnReset((formValues) => ({
                  ...formValues,
                  StatusId: StandardConst.RegulrizationStatus.Approved,
                }));
              }}
            >
              Approve
            </Button>
            <Button
              variant="danger"
              id="btnReject"
              type="submit"
               disabled={mode === "view"}
              onClick={() => {
                formRef.current.fnReset((formValues) => ({
                  ...formValues,
                  StatusId: StandardConst.RegulrizationStatus.Rejected,
                }));
              }}
            >
              Reject
            </Button>
          </Modal.Footer>
        {/* // )} */}
      </Form>
    </Modal>
  );
};

export default forwardRef(ApproveRejectRegularization);